/** Generated by scripts/lesson_plans/export_feed_from_lessons.py — do not edit by hand. */

const EXAMPLES = {
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-kp-1": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-kp-2": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-kp-3": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-kp-4": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-kp-5": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-2-settlement-and-the-gaelic-atlantic-world": {
    "kind": "none",
    "illustrationPlan": "Settlement and the Gaelic Atlantic world",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-3-fiddle-style-what-to-listen-for": {
    "kind": "none",
    "illustrationPlan": "Fiddle style: what to listen for — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-4-step-dance-and-square-sets": {
    "kind": "none",
    "illustrationPlan": "Step dance and square sets — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-5-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-6-transmission-today": {
    "kind": "none",
    "illustrationPlan": "Transmission today — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-7-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-01-cape-breton-sec-8-reading-list": {
    "kind": "none",
    "illustrationPlan": "Reading list — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-kp-1": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-kp-2": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-kp-3": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-kp-4": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-kp-5": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-kp-6": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-2-the-gaita-and-its-ensemble": {
    "kind": "none",
    "illustrationPlan": "The gaita and its ensemble — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-3-muiñeira-and-dance-repertoire": {
    "kind": "none",
    "illustrationPlan": "Muiñeira and dance repertoire — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-4-pan-celtic-networks-and-modern-scenes": {
    "kind": "none",
    "illustrationPlan": "Pan-Celtic networks and modern scenes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-5-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-6-study-habits-for-learners": {
    "kind": "none",
    "illustrationPlan": "Study habits for learners — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-7-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-02-galicia-asturias-sec-8-reading-list": {
    "kind": "none",
    "illustrationPlan": "Reading list — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-kp-1": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-kp-2": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-kp-3": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-kp-4": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-kp-5": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-kp-6": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-2-cornwall-mines-methodism-and-kernow-identity": {
    "kind": "none",
    "illustrationPlan": "Cornwall: mines, Methodism, and Kernow identity",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-3-isle-of-man-manx-song-dance-and-festival-life": {
    "kind": "none",
    "illustrationPlan": "Isle of Man: Manx song, dance, and festival life",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-4-instruments-and-repertoire-notes": {
    "kind": "none",
    "illustrationPlan": "Instruments and repertoire notes — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-5-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-6-why-these-regions-matter-in-the-celtic-map": {
    "kind": "none",
    "illustrationPlan": "Why these regions matter in the Celtic map",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-03-cornwall-man-sec-7-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-kp-1": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-kp-2": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-kp-3": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-kp-4": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-kp-5": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-kp-6": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-sec-2-lorient-the-flagship-interceltique": {
    "kind": "none",
    "illustrationPlan": "Lorient: the flagship Interceltique — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-sec-3-celtic-connections-winter-session-city": {
    "kind": "none",
    "illustrationPlan": "Celtic Connections: winter session city — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-sec-4-congresses-councils-and-touring-networks": {
    "kind": "none",
    "illustrationPlan": "Congresses, councils, and touring networks",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-sec-5-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-04-pan-celtic-festivals-sec-7-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-kp-1": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (1) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-kp-2": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (2) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-kp-3": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (3) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-kp-4": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (4) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-kp-5": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (5) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-kp-6": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: key ideas (6) — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-1-overview": {
    "kind": "none",
    "illustrationPlan": "Overview — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-2-method-the-four-column-listen": {
    "kind": "none",
    "illustrationPlan": "Method: the four-column listen — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-3-exercise-1-reel-family-across-atlantic-shores": {
    "kind": "none",
    "illustrationPlan": "Exercise 1: reel family across Atlantic shores",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-5-exercise-3-pipe-voices": {
    "kind": "none",
    "illustrationPlan": "Exercise 3: pipe voices — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-8-building-your-comparative-playlist": {
    "kind": "none",
    "illustrationPlan": "Building your comparative playlist — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-9-compared-with-ireland": {
    "kind": "none",
    "illustrationPlan": "Compared with Ireland — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-sec-10-key-points": {
    "kind": "none",
    "illustrationPlan": "Key points — listen for regional style, session context, and tune form.",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-tune-silver-spear-compare": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: The Silver Spear (Ireland anchor)",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-tune-masons-apron-compare": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: The Mason's Apron (cross-border)",
    "imageUrl": ""
  },
  "celtic-diaspora-regions-celtic-diaspora-05-listening-across-borders-tune-gavotte-compare": {
    "kind": "none",
    "illustrationPlan": "Diaspora trad: Breton gavotte (contrast)",
    "imageUrl": ""
  }
}

export default EXAMPLES
